module.exports = __webpack_public_path__ + "static/media/dev.943f64fb.svg";